<span class="material-icons lib-spinner"> donut_large </span>
